import React from 'react';
import { MainLayout } from '@components';
import LabResultComponents from './LabResult';

export default function LabResultPage(props) {
  return (
    <MainLayout footer="main" children={<LabResultComponents {...props} />} />
  );
}
